import { createStyles, Theme } from '@material-ui/core';

const styles = ({
  custom: {
    palette: { colorSupportSnow },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    root: {},
    toolbarRoot: {
      width: '100%',
      height: `${unit * 7 + 4}px`,
      zIndex: 50,
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      width: 138,
      paddingBlock: `${unit}px`,
      height: `${unit * 7 + 3}px`,
    },
    content: {
      backgroundColor: colorSupportSnow,
      width: 'calc(100% - 216px)',
      height: '100vh',
      marginLeft: 'auto',
      paddingBlock: `${unit * 12 + 4}px`,
      paddingInline: `${unit * 6}px`,
      display: 'flex',
      flexDirection: 'column',
      gap: `${unit * 2}px`,
    },
    sidebar: {
      width: 216,
      insetBlock: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: `${unit * 3}px`,
      paddingBlock: `${unit * 13}px`,
      position: 'fixed',
      left: 0,
    },
  });

export default styles;
